import React from 'react'
import { Link } from 'react-router-dom'
import '../personaverification/PersonaVerification.css'

const PersonaVerification = () => {
  return (
    <div className='persona-verification-section w-100 position-relative'>
        <Link rel='stylesheet' to="/signup" className='back-btn'>Back</Link>
        <div className='persona-verification-code-box d-flex flex-wrap align-content-center justify-content-center'>
            <Link rel='stylesheet' to="/signup-category" className='go-next'>Persona Verification</Link>
        </div>
    </div>
  )
}

export default PersonaVerification
